import { STATUS_LABELS } from '@launchpad/shared';

export function ActivityTimeline({ statusHistory = [] }) {
  if (statusHistory.length === 0) {
    return <p className="text-sm text-slate-400 italic">No status changes yet</p>;
  }

  const sorted = [...statusHistory].reverse();

  return (
    <div className="space-y-3">
      {sorted.map((entry, i) => (
        <div key={i} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className="size-2 rounded-full bg-primary-400 mt-1.5" />
            {i < sorted.length - 1 && <div className="w-px flex-1 bg-slate-200" />}
          </div>
          <div className="pb-3">
            <p className="text-sm text-slate-700">
              <span className="font-medium">{STATUS_LABELS[entry.from] || entry.from}</span>
              {' → '}
              <span className="font-medium">{STATUS_LABELS[entry.to] || entry.to}</span>
            </p>
            <p className="text-xs text-slate-400">
              {new Date(entry.timestamp).toLocaleDateString(undefined, {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
